// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Tooltip_wrap__2sBTn"};